export const EDIT_ORDER = 'EDIT_ORDER'
export const EDIT_ORDER_FAILS = 'EDIT_ORDER_FAILS'
export const EDIT_ORDER_SUCCESS = 'EDIT_ORDER_SUCCESS'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS'
export const UPDATE_ORDER_FAILS = 'UPDATE_ORDER_FAILS'
export const DELETE_ORDER_FROM_EDIT_ORDER_SUCCESS = 'DELETE_ORDER_FROM_EDIT_ORDER_SUCCESS'
export const DELETE_ORDER_FROM_EDIT_ORDER = 'DELETE_ORDER_FROM_EDIT_ORDER'
export const DELETE_ORDER_FROM_EDIT_ORDER_FAILS = 'DELETE_ORDER_FROM_EDIT_ORDER_FAILS'
export const CHANGE_INFOR_EDIT_ORDER = 'CHANGE_INFOR_EDIT_ORDER'
export const CHANGE_ITEM_EDIT_ORDER = 'CHANGE_ITEM_EDIT_ORDER'
export const CHECKED_ALL_ITEMS_EDIT_ORDER = 'CHECKED_ALL_ITEMS_EDIT_ORDER'
export const CHANGE_CLASSES_EDIT_ORDER = 'CHANGE_CLASSES_EDIT_ORDER'
export const CHANGE_EDIT_ORDER = 'CHANGE_EDIT_ORDER'
export const SEARCH_ITEM_CODE_EDIT_ORDER = 'SEARCH_ITEM_CODE_EDIT_ORDER'
export const CHECK_POSTAL_CODE_EDIT_ORDER_SUCCESS = 'CHECK_POSTAL_CODE_EDIT_ORDER_SUCCESS'
export const CHECK_POSTAL_CODE_EDIT_ORDER = 'CHECK_POSTAL_CODE_EDIT_ORDER'
export const CHECK_POSTAL_CODE_EDIT_ORDER_FAILS = 'CHECK_POSTAL_CODE_EDIT_ORDER_FAILS'
export const ADD_ORDER_FROM_SHIPMENT_FAILS = 'ADD_ORDER_FROM_SHIPMENT_FAILS'
export const ADD_ORDER_FROM_SHIPMENT_SUCCESS = 'ADD_ORDER_FROM_SHIPMENT_SUCCESS'
export const ADD_ORDER_FROM_SHIPMENT = 'ADD_ORDER_FROM_SHIPMENT'
export const STATE_INFORMATION_DEFAULT_EDIT_ORDER = 'STATE_INFORMATION_DEFAULT_EDIT_ORDER'
export const STATE_INFORMATION_CLASSES_DEFAULT_EDIT_ORDER = 'STATE_INFORMATION_CLASSES_DEFAULT_EDIT_ORDER'
export const RESTORE_ORDER = 'RESTORE_ORDER'
export const CONVERT_NAME_EDIT_ORDER = 'CONVERT_NAME_EDIT_ORDER'
export const CONVERT_NAME_EDIT_ORDER_SUCCESS = 'CONVERT_NAME_EDIT_ORDER_SUCCESS'
export const CONVERT_NAME_EDIT_ORDER_FAILS = 'CONVERT_NAME_EDIT_ORDER_FAILS'
export const CANCEL_ROW_EDIT_ORDER = 'CANCEL_ROW_EDIT_ORDER'
export const CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON = 'CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON'
export const CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON_SUCCESS = 'CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON_SUCCESS'

export const editOrderSuccess = (payload) => {
    return {
        type: EDIT_ORDER_SUCCESS,
        payload
    }
}

export const editOrder = (payload) => {
    return {
        type: EDIT_ORDER,
        payload
    }
}

export const editOrderFails = (payload) => {
    return {
        type: EDIT_ORDER_FAILS,
        payload
    }
}

export const updateOrder = (payload) => {
    return {
        type: UPDATE_ORDER,
        payload
    }
}

export const updateOrderFails = (payload) => {
    return {
        type: UPDATE_ORDER_FAILS,
        payload
    }
}

export const updateOrderSuccess = (payload) => {
    return {
        type: UPDATE_ORDER_SUCCESS,
        payload
    }
}

export const deleteOrderFromEditOrder = (payload) => {
    return {
        type: DELETE_ORDER_FROM_EDIT_ORDER,
        payload
    }
}

export const deleteOrderFromEditOrderFails = (payload) => {
    return {
        type: DELETE_ORDER_FROM_EDIT_ORDER_FAILS,
        payload
    }
}

export const deleteOrderFromEditOrderSuccess = (payload) => {
    return {
        type: DELETE_ORDER_FROM_EDIT_ORDER_SUCCESS,
        payload
    }
}

export function changeInforEditOrder(payload) {
    return {
        type: CHANGE_INFOR_EDIT_ORDER,
        payload,
    }
}

export function changeItemEditOrder(payload) {
    return {
        type: CHANGE_ITEM_EDIT_ORDER,
        payload,
    }
}

export function checkedAllItemsEditOrder(payload) {
    return {
        type: CHECKED_ALL_ITEMS_EDIT_ORDER,
        payload,
    }
}

export function changeClassesEditOrder(payload) {
    return {
        type: CHANGE_CLASSES_EDIT_ORDER,
        payload,
    }
}

export function changeEditOrder(payload) {
    return {
        type: CHANGE_EDIT_ORDER,
        payload,
    }
}

export function searchItemCodeEditOrder(payload) {
    return {
        type: SEARCH_ITEM_CODE_EDIT_ORDER,
        payload: payload,
    }
}

export function checkPostalCodeEditOrderSuccess(payload) {
    return {
        type: CHECK_POSTAL_CODE_EDIT_ORDER_SUCCESS,
        payload: payload,
    }
}

export function checkPostalCodeEditOrder(payload) {
    return {
        type: CHECK_POSTAL_CODE_EDIT_ORDER,
        payload: payload,
    }
}

export function checkPostalCodeEditOrderFails(payload) {
    return {
        type: CHECK_POSTAL_CODE_EDIT_ORDER_FAILS,
        payload: payload,
    }
}

export function addOrderFromShipmentFails(payload) {
    return {
        type: ADD_ORDER_FROM_SHIPMENT_FAILS,
        payload,
    }
}

export function addOrderFromShipmentSuccess(payload) {
    return {
        type: ADD_ORDER_FROM_SHIPMENT_SUCCESS,
        payload,
    }
}

export function addOrderFromShipment(payload) {
    return {
        type: ADD_ORDER_FROM_SHIPMENT,
        payload,
    }
}

export function stateInformationDefaultEditOrder(payload) {
    return {
        type: STATE_INFORMATION_DEFAULT_EDIT_ORDER,
        payload,
    }
}

export function stateInformationClassesDefaultEditOrder(payload) {
    return {
        type: STATE_INFORMATION_CLASSES_DEFAULT_EDIT_ORDER,
        payload,
    }
}

export function restoreOrder(payload) {
    return {
        type: RESTORE_ORDER,
        payload,
    }
}

export function convertNameEditOrder(payload) {
    return {
        type: CONVERT_NAME_EDIT_ORDER,
        payload: payload,
    }
}

export function convertNameSuccessEditOrder(payload) {
    return {
        type: CONVERT_NAME_EDIT_ORDER_SUCCESS,
        payload: payload,
    }
}

export function convertNameFailsEditOrder(payload) {
    return {
        type: CONVERT_NAME_EDIT_ORDER_FAILS,
        payload: payload,
    }
}

export function cancelRowEditOrder(payload) {
    return {
        type: CANCEL_ROW_EDIT_ORDER,
        payload: payload,
    }
}

export function channelOrderItemOfOrderFromAmazon(payload) {
    return {
        type: CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON,
        payload: payload,
    }
}

export function channelOrderItemOfOrderFromAmazonSuccess(payload) {
    return {
        type: CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON_SUCCESS,
        payload: payload,
    }
}



// WEBPACK FOOTER //
// ./src/actions/editOrder.js